import PartnersSuccess from "./PartnersSuccess";

export default PartnersSuccess;
